import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../Components/ComboBox'
import { Input } from '../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import { Box, IconButton } from '@mui/material'
import { convertToMuiDate, currentDate } from '../../../utils/helpers'
import { CustomTextField } from '../../../Components/CustomTextField'
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined'
import moment from 'moment'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function CreateObjectifsForm({
  setObjectifs,
  objectifsMetadata,
  buttonIcon = false,
  fromUserWizard = false,
  selectedVal = '',
  setCreateObjif = false,
  setSelectedObjifList = null,
  openFromUrl = false,
  onUrlOpenConsumed = null,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(false)
  const [state, setState] = useState({
    predefinedObjectives: [],
    value_format: [],
  })
  const [formValues, setFormValues] = useState({
    domain: null,
    objectives_name: null,
    unit_of_measurement: null,
    objectifs: '',
    periodicity: null,
    date_objectives: currentDate(),
  })

  useEffect(() => {
    if (fromUserWizard || openFromUrl) {
      handleClickOpen()
      if (openFromUrl && onUrlOpenConsumed) onUrlOpenConsumed()
    }
  }, [fromUserWizard, openFromUrl, onUrlOpenConsumed])
  useEffect(() => {
    const { domain } = formValues

    if (domain !== null && domain.length !== 0 && objectifsMetadata.predefinedObjectives) {
      state.predefinedObjectives = objectifsMetadata.predefinedObjectives.filter(
        (v) => v.domain === domain.id,
      )
      setState({ ...state })
    } else {
      state.predefinedObjectives = []
      setState({ ...state })
      formValues.objectives_name = null
      formValues.unit_of_measurement = null
      setFormValues({ ...formValues })
    }
  }, [formValues.domain])

  useEffect(() => {
    const { objectives_name } = formValues
    if (state.predefinedObjectives.length !== 0 && objectives_name !== null) {
      state.value_format = objectifsMetadata.predefinedObjectives.filter(
        (v) => v.id === objectives_name.id,
      )
      state.value_format = state.value_format.map((v) => ({
        label: v.value,
        id: v.id,
      }))
      setState({ ...state })
    }
    if (formValues.objectives_name === null) {
      formValues.unit_of_measurement = null
      state.value_format = []
      setFormValues({ ...formValues })
      setState({ ...state })
    }
  }, [formValues.objectives_name])

  useEffect(() => {
    if (!open || !selectedVal || !objectifsMetadata.predefinedObjectives?.length) return
    if (formValues.objectives_name?.label === selectedVal) return

    const selectedObjective = objectifsMetadata.predefinedObjectives.find(
      (e) => e.label === selectedVal,
    )
    if (!selectedObjective) return

    const valueFormats = objectifsMetadata.predefinedObjectives
      .filter((v) => v.id === selectedObjective.id)
      .map((v) => ({ label: v.value, id: v.id }))

    setState({
      predefinedObjectives: objectifsMetadata.predefinedObjectives.filter(
        (v) => v.domain === selectedObjective.domain,
      ),
      value_format: valueFormats,
    })
    setFormValues({
      ...formValues,
      domain: objectifsMetadata.domains?.find((e) => e.id === selectedObjective.domain) || null,
      objectives_name: selectedObjective,
      unit_of_measurement: valueFormats.find((e) => e.label === selectedObjective.value) || null,
      periodicity: objectifsMetadata.frequency?.find((e) => e.label === 'Mois') || null,
      date_objectives: convertToMuiDate(moment().add(1, 'year').format('DD-MM-YYYY')),
    })
  }, [open, selectedVal, objectifsMetadata, formValues])

  const handleClickOpen = () => {
    setOpen(true)
    if (
      selectedVal !== null &&
      selectedVal.length !== 0 &&
      objectifsMetadata.predefinedObjectives
    ) {
      let domain = objectifsMetadata.predefinedObjectives.find((e) => e.label === selectedVal)
      if (domain) {
        state.predefinedObjectives = objectifsMetadata.predefinedObjectives.filter(
          (v) => v.domain === domain.id,
        )
        state.value_format = objectifsMetadata.predefinedObjectives.filter(
          (v) => v.id === domain.id,
        )
        state.value_format = state.value_format.map((v) => ({
          label: v.value,
          id: v.id,
        }))
        setState({ ...state })
        formValues.domain = objectifsMetadata.domains.find((e) => e.id === domain.domain)
        formValues.objectives_name = domain
        formValues.unit_of_measurement = state.value_format.find((e) => e.label === domain.value)
        formValues.periodicity = objectifsMetadata.frequency.find((e) => e.label === 'Mois')
        formValues.date_objectives = convertToMuiDate(moment().add(1, 'year').format('DD-MM-YYYY'))
        setFormValues({ ...formValues })
      }
    }
  }

  const handleClose = () => {
    setOpen(false)
    setFormValues({
      domain: null,
      objectives_name: null,
      unit_of_measurement: null,
      objectifs: '',
      periodicity: null,
      date_objectives: currentDate(),
    })
    if (fromUserWizard) {
      setCreateObjif(false)
    }
  }

  const handleChange = (i, j) => {
    setFormValues({ ...formValues, [i]: j })
  }
  const onSubmit = async (e) => {
    e.preventDefault()
    const payload = {
      ...formValues,
      domain: formValues.domain.id,
      objectives_name: formValues.objectives_name.id,
      periodicity: formValues.periodicity.id,
      unit_of_measurement: formValues.unit_of_measurement.label,
    }
    if (fromUserWizard) {
      setSelectedObjifList((prev) => [...prev, formValues])
      handleClose()
      return
    }
    const response = await makePostRequest(urls.crudMesObjectifs, payload, {}, true)
    if (response.status === 201) {
      setObjectifs((objectifs) => ({
        ...objectifs,
        results: [...objectifs.results, response.data],
        count: objectifs.count + 1,
      }))
      handleClose()
      setState({ predefinedObjectives: [], value_format: [] })
      setFormValues({
        domain: null,
        objectives_name: null,
        unit_of_measurement: null,
        objectifs: '',
        periodicity: null,
        date_objectives: currentDate(),
      })
    }
  }

  return (
    <>
      {fromUserWizard ? (
        ''
      ) : (
        <>
          {buttonIcon ? (
            <IconButton sx={{ color: 'white' }} onClick={handleClickOpen}>
              <ControlPointOutlinedIcon />
            </IconButton>
          ) : (
            <CustomButton onClick={handleClickOpen}>{t('mesObjectifs.add')}</CustomButton>
          )}
        </>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{t('mesObjectifs.createDialogTitle')}</DialogTitle>
        <form onSubmit={onSubmit}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(i, j) => {
                if (selectedVal) {
                  formValues.objectives_name = null
                  formValues.unit_of_measurement = null
                  setFormValues({ ...formValues })
                }
                handleChange(i, j)
              }}
              label={t('mesObjectifs.domainLabel')}
              data={objectifsMetadata.domains || []}
              name="domain"
              required
              // value={formValues.domain}
              selectedValue={formValues.domain}
            />

            <ComboBox
              handleAutoComplete={handleChange}
              label={t('mesObjectifs.objectivesLabel')}
              data={state.predefinedObjectives || []}
              name="objectives_name"
              required
              // value={formValues.objectives_name}
              selectedValue={formValues.objectives_name}
            />
            <ComboBox
              handleAutoComplete={handleChange}
              label={t('mesObjectifs.unitOfMeasureLabel')}
              data={state.value_format || []}
              name="unit_of_measurement"
              required
              // value={formValues.unit_of_measurement}
              selectedValue={formValues.unit_of_measurement}
            />
            <CustomTextField
              name="objectifs"
              onChange={(e) => setFormValues({ ...formValues, objectifs: e.target.value })}
              label={t('mesObjectifs.valueLabel')}
              variant="outlined"
              type="number"
              required
              fullWidth
              size="small"
              value={formValues.objectifs}
            />
            <CustomTextField
              name="date_objectives"
              label={t('mesObjectifs.dateOfObjectiveLabel')}
              variant="outlined"
              type="date"
              required
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  date_objectives: e.target.value,
                })
              }
              fullWidth
              size="small"
              value={formValues.date_objectives}
            />
            <ComboBox
              handleAutoComplete={handleChange}
              label={t('mesObjectifs.periodicityLabel')}
              data={objectifsMetadata.frequency || []}
              name="periodicity"
              required
              selectedValue={formValues.periodicity}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('mesObjectifs.validate')}</Button>
            <Button onClick={handleClose}>{t('mesObjectifs.cancel')}</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
